import * as React from "react";
import * as Immutable from "immutable";
import TeamsAssignment from "../teams-assignment/TeamsAssignment";
import TeamsDomain from "../../domainActions/TeamsDomain";
const UserTeamsAssignment = ({ user, readOnly }) => {
  const _getUnassignedTeams = (teams) => teams.filter((t) => !t.users.includes(user.id) && !t.isSynced).toList();
  const _loadAssignedTeams = (pagination) => TeamsDomain.loadTeamsForUser(user.id, pagination);
  const _unassignTeam = (teamId) => TeamsDomain.removeMember(teamId, user.id);
  const _assignTeams = (teamIds) => TeamsDomain.addMemberToTeams(user.id, teamIds);
  const _buildTeamWithEntity = (team) => team.toBuilder().users(Immutable.Set([user.id])).build();
  return /* @__PURE__ */ React.createElement(
    TeamsAssignment,
    {
      getUnassignedTeams: _getUnassignedTeams,
      readOnly,
      loadAssignedTeams: _loadAssignedTeams,
      unassignTeam: _unassignTeam,
      buildTeamWithEntity: _buildTeamWithEntity,
      assignTeams: _assignTeams
    }
  );
};
export default UserTeamsAssignment;
